import {
  Box,
  Card,
  Grid,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

// import { ReactComponent as ContactsIcon } from "../../assets/contacts-menu-icon.svg";  // unused while the s1v tiles above are commented out
// import { ReactComponent as ReportsIcon } from "../../assets/reports-menu-icon.svg";  // unused while the s1v tiles above are commented out
// import { ReactComponent as CreateInvoiceIcon } from "../../assets/create-invoice.svg";  // unused while the s1v tiles above are commented out
// import { ReactComponent as TimesheetIcon } from "../../assets/timesheet.svg";  // unused while the s1v tiles above are commented out
import { ReactComponent as BankFeedsIcon } from "../../assets/bank-feeds.svg";
// import { ReactComponent as InvoicesListIcon } from "../../assets/invoices-list.svg";  // unused while the s1v tiles above are commented out
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import numeral from "numeral";
import { useLoginPopup } from "../../context/LoginPopupContext";
import BackdropLoading from "../../components/BackdropLoading/BackdropLoading";
import { createSessionForExternal } from "../../utils/common";
import { getCookie, getHeaders } from "../../utils/api";
import { PageTitle } from "../../pages/CreateBusinessAccount/CreateBusinessAccount";
import envConfig from "../../config";

// COMMENTED OUT 2026-09-22 (Tom: "comment them out, we should not be using this. it should be dead
// for months now"). Every tile below pointed at s1v.{root} - the old front end - which returns 404
// on the root and on these deep paths, so all five have been broken links for some time.
//
// They are not repointed at app.{root} because the paths do not exist there: none of
// invoice/standard, timesheet/list, invoice/list, contacts/list or reports/dashboard appears in
// app-exacc. Choosing the replacement routes is a decision for whoever owns that app, so the tiles
// are parked rather than quietly aimed somewhere else.
const getClickable = (dbiD) => {
  return [
    // {
    //   label: "Create Invoice",
    //   icon: <CreateInvoiceIcon />,
    //   url: `https://${envConfig.correspondingService}/${dbiD}/invoice/standard`,
    // },
    // {
    //   label: "Timesheet",
    //   icon: <TimesheetIcon />,
    //   url: `https://${envConfig.correspondingService}/${dbiD}/timesheet/list`,
    // },
    { label: "Bank Feeds", icon: <BankFeedsIcon />, url: "#" },
    // {
    //   label: "Invoices list",
    //   icon: <InvoicesListIcon />,
    //   url: `https://${envConfig.correspondingService}/${dbiD}/invoice/list`,
    // },
    // {
    //   label: "Contacts list",
    //   icon: <ContactsIcon />,
    //   url: `https://${envConfig.correspondingService}/${dbiD}/contacts/list`,
    // },
    // {
    //   label: "Reports",
    //   icon: <ReportsIcon />,
    //   url: `https://${envConfig.correspondingService}/${dbiD}/reports/dashboard`,
    // },
  ];
};

const DashboardMobile = () => {
  const databaseIdFromCookies = getCookie("databaseId");
  const { dbId, lang } = useParams();
  const urlPrefix = `/${dbId || databaseIdFromCookies}/${lang || "en-au"}`;

  const navigate = useNavigate();

  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);

  const [data, setData] = useState([]);

  const [userFirstName, setUserFirstName] = useState("");
  const [clickable, setClickable] = useState([]);
  const [loading, setLoading] = useState(true);

  const { enqueueSnackbar } = useSnackbar();
  const { handleOpen } = useLoginPopup();

  const fetchData = async () => {
    setLoading(true);
    const LinkA = localStorage.getItem("savedReferrer");
    const indexOfCom = LinkA.indexOf(".com");
    const indexOfAu = LinkA.indexOf(".au");

    const substringEndIndex =
      indexOfCom !== -1
        ? indexOfCom + 4
        : indexOfAu !== -1
        ? indexOfAu + 3
        : LinkA.length;

    const finalLinkA = LinkA.substring(0, substringEndIndex);
    try {
      const response = await fetch(
        `https://${envConfig.apiDev2}/api/front-end/get-mobile-dashboard-data?BaseHostURL=${envConfig.loginUrl}`,
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify({
            LinkA:
              !LinkA ||
              LinkA == "undefined" ||
              LinkA?.includes(`${envConfig.loginUrl}`)
                ? `https://${envConfig.correspondingService}`
                : finalLinkA,
            LinkS: "",
            Lang: "en-au",
            LinkMy:
              envConfig.loginPortalUrl ||
              (window.location.origin.includes("my.exx.au")
                ? "my.exx.au"
                : window.location.origin.includes("my.exacc.au")
                ? "my.exacc.au"
                : "my.ssx.com"),
          }),
        }
      );

      const responseData = await response.json();
      if (responseData.SuccessYN === "Y") {
        setLoading(false);
        setData(responseData.Data);
        setUserFirstName(responseData.UserFirstName);
      } else {
        setLoading(false);
        handleOpen();
        // Error handled by interceptor
      }
    } catch (error) {
      setLoading(false);
      handleOpen();
      // Error handled by interceptor
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setClickable(getClickable(getCookie("databaseId")));
  }, [getCookie("databaseId")]);

  return (
    <Box sx={{ mb: 8 }}>
      <BackdropLoading open={loading} />
      <Box sx={{ mb: 2 }}>
        <PageTitle title={userFirstName ? `Hi, ${userFirstName}!` : "Hi!"} />
        {data?.BusinessName && (
          <Typography sx={{ fontWeight: 600, color: "darkgray" }}>
            {data.BusinessName}
          </Typography>
        )}
      </Box>
      <Grid container alignItems="baseline" spacing={2}>
        {clickable.map(({ label, icon, url }, index) => (
          <Grid item xs={4} key={index}>
            <Card
              onClick={() => {
                if (url.startsWith("http")) {
                  createSessionForExternal(url);
                } else {
                  navigate(`${urlPrefix}${url}`);
                }
              }}
              sx={{
                textAlign: "center",
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px rgba(69, 90, 100, 0.1)",
                border: theme.palette.borders.main,
                padding: "15px 5px",
                cursor: "pointer",
                height: "100%",
                color: theme.typography.linkColor,
                fill: theme.palette.text.main,
                "&:hover": {
                  color: theme.palette.primary.main,
                  fill: theme.palette.primary.main,
                  path: {
                    fill: theme.navigation.hoverMenuItemColor,
                  },
                },
              }}
            >
              <Box
                sx={{
                  color: theme.palette.primary.main,
                  "svg path": {
                    fill: isDarkMode ? "#fff" : "#818595",
                  },
                }}
              >
                {icon}
              </Box>
              <Box
                sx={{
                  margin: "0px",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  letterSpacing: "0.15px",
                }}
              >
                {label}
              </Box>
            </Card>
          </Grid>
        ))}

        {data?.length > 0 && (
          <Box
            sx={{
              width: "100%",
              borderRadius: 1,
              margin: "20px 0 20px 15px",
              backgroundColor: theme.palette.blackWhite,
              boxShadow: "0px 0px 10px 0px rgba(69, 90, 100, 0.1)",
              border: theme.palette.borders.main,
              padding: "20px",
            }}
          >
            <Box>
              <Typography
                sx={{
                  mb: "20px",
                  color: theme.typography.linkColor,
                  fontSize: "24px",
                  fontWeight: 400,
                  letterSpacing: "-0.264px",
                }}
              >
                Business summary
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              {data?.map(({ Label, Value, Url }, index) => (
                <Box
                  sx={{
                    cursor: "pointer",
                    py: "6px",
                    my: 0,
                    px: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    "&:hover": {
                      backgroundColor: isDarkMode ? "#1E1E1E" : "#f4f4f4",
                    },
                  }}
                  key={index}
                  onClick={() => {
                    if (Url.startsWith("https")) {
                      createSessionForExternal(Url);
                    } else {
                      navigate(`${Url}`);
                    }
                  }}
                  data-testid={`business-summary-item-${index}`}>
                  <Typography>{Label}</Typography>
                  <Typography sx={{ fontWeight: 600 }}>
                    {Value >= 0
                      ? `$${numeral(Math.abs(Value)).format("0,0.00")}`
                      : `($${numeral(Math.abs(Value)).format("0,0.00")})`}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default DashboardMobile;
